import './style/Main.scss';

import * as Sentry from '@sentry/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import mixpanel from 'mixpanel-browser';
import { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

import App from './App';
import { DSN, ROOT_URL } from './config';
import store from './Redux/store';

function extractTokensFromHash() {
  // check tokens in URL hash
  const hash = window.location.hash.slice(1); // removes leading '#'
  if (hash) {
    const params = new URLSearchParams(hash);
    if (
      params.has('access_token') &&
      params.has('refresh_token') &&
      (params.has('expire_at') || params.has('expires_at'))
    ) {
      const access_token = params.get('access_token');
      const refresh_token = params.get('refresh_token');
      const token_expires_at = params.get('expire_at') || params.get('expires_at');
      if (access_token && refresh_token && token_expires_at) {
        console.info('----valid all incoming tokens');
        localStorage.setItem('access_token', access_token);
        localStorage.setItem('refresh_token', refresh_token);
        localStorage.setItem('token_expires_at', token_expires_at);

        // clear the hash
        window.history.replaceState(null, '', window.location.pathname);
      }
    }
  }
}

// Execute before app renders
extractTokensFromHash();

Sentry.init({
  dsn: DSN,
  integrations: [
    // See docs for support of different versions of variation of react router
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],

  tracesSampleRate: 1.0,
  environment: ROOT_URL.includes('-staging-') ? 'Staging' : 'Production',
});
const email = localStorage.getItem('userEmail');
Sentry.setTag('userEmail', email);

if (ROOT_URL.includes('-staging-')) {
  mixpanel.init('86613cf3bb2a15fe378dd113032b8634', { debug: true });
} else {
  mixpanel.init('f7bbbe310a7585246424dbd6a0e248f0', { debug: false });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <App />
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </Provider>
);
